module.exports = __webpack_public_path__ + "static/media/loading-spinner.15be5601.gif";